import React from 'react';

const SubCulture = () => {
  return (
    <section className='sub-text-box' id='sub-text-box'>
      <h1>Our Culture</h1>
      <p>JUST SHOW UP.</p>
    </section>
  );
};

export default SubCulture;
